import { toast } from 'react-toastify'

const error = (err = undefined, text) =>
  toast.error(
    <div>
      <div>Erreur survenue {text} :</div>
      {err && (
        <div
          dangerouslySetInnerHTML={{
            __html:
              err.response && err.response.data
                ? JSON.stringify(err.response.data)
                    .replaceAll(/[}{]/gi, ' ')
                    .replaceAll('[', ' ')
                    .replaceAll(']', ' ')
                    .replaceAll(',', '<br/>')
                : typeof err === 'string'
                ? err
                : JSON.stringify(err),
          }}
        />
      )}
    </div>
  )

export default error
